var React = require('react');

function ButtonArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","strokeWidth":"0.5","stroke":"#fff","d":"M11.3,11.7c-0.1,0-0.3,0.1-0.4,0.2l-4.5,4.5V0.5C6.4,0.2,6.2,0,5.9,0S5.4,0.2,5.4,0.5v15.8l-4.5-4.5\n\tc-0.2-0.2-0.6-0.2-0.8,0s-0.2,0.6,0,0.8L5.5,18c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0.1,0.3,0.1,0.4,0c0.1,0,0.1-0.1,0.2-0.1l5.5-5.5\n\tc0.2-0.2,0.2-0.6,0-0.8C11.5,11.7,11.4,11.7,11.3,11.7z"}));
}

ButtonArrow.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 12 18.2","style":{"enableBackground":"new 0 0 12 18.2"},"xmlSpace":"preserve"};

module.exports = ButtonArrow;

ButtonArrow.default = ButtonArrow;
